import React from 'react';
import SectionTitle from '../../../components/SectionTitle';
import GeneralBtn from '../../../components/GeneralBtn';
import { StyledCallToAction } from './styles/StyledCallToAction';

const CallToAction = ({ content, bgColor }) => {
  return (
    <StyledCallToAction style={{backgroundColor: bgColor}}>
      <div className="rn-section-gap">
        <div className="container">
          <div className="call-to-action-wrapper">
            <SectionTitle {...content.sectionTitle} />
            <GeneralBtn {...content.generalBtn} />
          </div>
        </div>
      </div>
    </StyledCallToAction>
  );
};

export default CallToAction;
